<h1 class="title">Update Financial Account</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times" /></button>

<div class="details-page-edit-form">
  <div class="form-title">Financial Account Details</div>

  <form [formGroup]="cardForm">
    <rkt-form [form]="cardForm" [fields]="accountCategoryFields" [model]="formModel" />
  </form>

  <form [formGroup]="financialAccountForm">
    <rkt-form class="name-field" [form]="financialAccountForm" [fields]="financialAccountFields" [model]="formModel" />
  </form>

  <form [formGroup]="cardInfoForm" [hidden]="isInternal || formModel.cardOrBankAccount === 'bankAccount'">
    <div class="form-title">Card Info</div>

    <rkt-form [form]="cardInfoForm" [fields]="cardFields" [model]="formModel" />

    <div class="form-title">Billing Info</div>

    <rkt-form [form]="cardInfoForm" [fields]="addressFields" [model]="formModel" />
  </form>

  <form [formGroup]="bankForm" [hidden]="isInternal || formModel.cardOrBankAccount === 'card'">
    <div class="form-title">Banking Info</div>

    <rkt-form [form]="bankForm" [fields]="bankFields" [model]="formModel" />
  </form>

  <form [formGroup]="addressForm" [hidden]="isInternal || formModel.cardOrBankAccount === 'card'">
    <div class="form-title">Billing Info</div>

    <div class="bank-account-address-description">
      *Plan to use a <span class="solution-name">wire transfer</span> on this account? Enter the address below, as a wire transfer requires
      an address to proceed.
    </div>

    <rkt-form [form]="addressForm" [fields]="addressFields" [model]="formModel" />
  </form>
  @if (formError) {
    <div class="details-page-edit-form-error">{{ formError }}</div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button rktButton type="submit" (click)="onSubmit()" [disabled]="isDisabled" title="Update Financial Account">Update</button>
  </div>
</div>
